/**
 * @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */

export const ROOT_EDITABLE_OPTIONS_ATTRIBUTE = '$rootEditableOptions';
